
export default {
  props: {
    data: {
      type: Object
    },
    viewMode: {
      type: String
    }
  },
  computed: {
    viewRatio () {
      let ratio
      if (this.viewMode === 'vod') {
        ratio = this.data.viewratio
      } else {
        ratio = this.data.viewratio
      }

      if (ratio.substring(0, 1) === 0) {
        return ratio.substring(2, 4)
      }
      ratio = ratio.replace('.', '')

      if (ratio > Math.max(100)) {
        ratio = 100
      } else if (ratio < Math.min(0)) {
        ratio = 0
      }
      return ratio
    }
  }
}
